module.exports = __webpack_public_path__ + "static/media/ecard_icon.0310f42b.svg";